import getBaseUrl from './getBaseUrl';
import axios from '../axiosConfig';

const getUrl = (path) => `${getBaseUrl()}identitysvc${path[0] !== '/' ? '/' : ''}${path}`;

const IdentitySvc = {
  /**
   * Get OIDC providers for a specific partner
   * @param partnerId
   */
  getPartnerOidcProviders: (partnerId) => axios.get(getUrl(`/partners/${partnerId}/oidc_providers`)),
};

export default IdentitySvc;
